// extracted by mini-css-extract-plugin
export default {"container":"LF-z","innerContainer":"MF-z","multipleLines":"NF-z","heading":"OF-z","content":"PF-z","linkColor":"QF-z"};